/* Back Door cart drawer layer (snippets/bd-cart-drawer.liquid).
   Dawn's assets/cart-drawer.js (open / close / focus trap / Escape /
   overlay) and assets/cart.js (quantity, remove via /cart/change.js) stay
   in charge; product-form.js renders the drawer after every add to cart.
   This file only wraps their methods to add:
   - free-shipping bar: animates from the previous position to the new one
     after every re-render, one pulse when the threshold is crossed;
   - the newly added line slides in (only that line); bag icon pulses once;
   - is-empty kept in sync after an add (Dawn leaves the class on the
     element, which breaks its focus trap);
   - skips Dawn's duplicate re-fetch right after a product-form add (the
     add response already re-rendered the drawer) so the new-line
     animation isn't cut off;
   - checkout sheen once per open; Continue shopping closes the drawer;
   - swipe right to close on touch screens;
   - a short "bag updated" status for screen readers.
   No timers loops, observers or extra network requests. */
(function () {
  if (window.bdCartDrawerReady) return;
  window.bdCartDrawerReady = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastShip = null; // last free-shipping fraction shown (0..1)
  var addStartedAt = 0;

  function drawer() {
    return document.querySelector('cart-drawer.bd-cart');
  }

  function shipFraction(root) {
    var el = (root || document).querySelector('cart-drawer.bd-cart [data-bd-ship]');
    if (!el) return null;
    var pct = parseFloat(el.dataset.bdShipPct);
    return isNaN(pct) ? null : Math.max(0, Math.min(1, pct / 100));
  }

  // Animate the freshly rendered bar from the previous fraction to its own.
  function animateShip() {
    var ship = document.querySelector('cart-drawer.bd-cart [data-bd-ship]');
    var next = shipFraction();
    if (!ship || next === null) {
      // empty bag = nothing spent yet: the next bar grows from 0
      var d = drawer();
      lastShip = d && d.classList.contains('is-empty') ? 0 : next;
      return;
    }
    var fill = ship.querySelector('.bd-cart__ship-fill');
    var from = lastShip === null ? next : lastShip;
    lastShip = next;
    if (!fill || from === next || reduceMotion.matches) return;
    fill.classList.remove('is-animating');
    fill.style.setProperty('--bd-ship', String(from));
    void fill.offsetWidth; // commit the start position
    fill.classList.add('is-animating');
    fill.style.setProperty('--bd-ship', String(next));
    if (from < 1 && next >= 1) {
      ship.classList.remove('is-celebrating');
      void ship.offsetWidth;
      ship.classList.add('is-celebrating');
    }
  }

  function announce() {
    var d = drawer();
    var region = document.getElementById('CartDrawer-LiveRegionText');
    if (!d || !region) return;
    var count = d.querySelector('.bd-cart__count');
    var subtotal = d.querySelector('[data-bd-cart-subtotal]');
    region.textContent = [
      'Bag updated',
      count ? count.textContent.trim() : '',
      subtotal ? 'Subtotal ' + subtotal.textContent.trim() : '',
    ]
      .filter(Boolean)
      .join('. ');
  }

  function pulseBag() {
    var bag = document.getElementById('cart-icon-bubble');
    if (!bag || reduceMotion.matches) return;
    bag.classList.remove('bd-bag-pulse');
    void bag.offsetWidth;
    bag.classList.add('bd-bag-pulse');
    bag.addEventListener(
      'animationend',
      function () {
        bag.classList.remove('bd-bag-pulse');
      },
      { once: true }
    );
  }

  function sheen(d) {
    if (!d || !d.classList.contains('bd-cart--sheen') || reduceMotion.matches) return;
    var button = d.querySelector('.bd-cart__checkout');
    if (!button) return;
    button.classList.remove('is-sheen');
    // after the panel has (almost) landed
    window.setTimeout(function () {
      void button.offsetWidth;
      button.classList.add('is-sheen');
    }, 220);
    button.addEventListener(
      'animationend',
      function () {
        button.classList.remove('is-sheen');
      },
      { once: true }
    );
  }

  // Product forms: remember that an add is in flight (see onCartUpdate).
  document.addEventListener(
    'submit',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('product-form')) addStartedAt = Date.now();
    },
    true
  );

  // Continue shopping: just close the drawer (the empty state's link
  // keeps working as a normal link without JS).
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bd-cart-continue]');
    if (!trigger) return;
    var d = trigger.closest('cart-drawer');
    if (!d || typeof d.close !== 'function') return;
    event.preventDefault();
    d.close();
  });

  // Swipe right to close (touch). Only a clear horizontal gesture that
  // doesn't start on the quantity / remove controls; vertical scrolling of
  // the item list is never blocked (passive listeners).
  var swipe = null;
  document.addEventListener(
    'touchstart',
    function (event) {
      var panel = event.target.closest && event.target.closest('cart-drawer.bd-cart.active .bd-cart__panel');
      if (!panel || event.touches.length !== 1) return (swipe = null);
      if (event.target.closest('quantity-input, cart-remove-button, input, textarea, select, details')) return (swipe = null);
      var t = event.touches[0];
      swipe = { x: t.clientX, y: t.clientY, at: Date.now() };
    },
    { passive: true }
  );
  document.addEventListener(
    'touchend',
    function (event) {
      if (!swipe) return;
      var t = event.changedTouches[0];
      var dx = t.clientX - swipe.x;
      var dy = Math.abs(t.clientY - swipe.y);
      var quick = Date.now() - swipe.at < 700;
      swipe = null;
      if (dx > 70 && dy < dx * 0.5 && quick) {
        var d = drawer();
        if (d && d.classList.contains('active')) d.close();
      }
    },
    { passive: true }
  );

  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');
    var proto = CartDrawer.prototype;

    var originalRender = proto.renderContents;
    proto.renderContents = function (parsedState) {
      // An add always leaves the bag non-empty.
      this.classList.remove('is-empty');
      originalRender.call(this, parsedState);
      addStartedAt = Date.now(); // keep skipping the duplicate re-fetch briefly
      animateShip();
      announce();
      pulseBag();
      var key = parsedState && parsedState.key;
      if (key && !reduceMotion.matches) {
        var row = this.querySelector('.bd-cart-item[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
        if (row) row.classList.add('is-new');
      }
    };

    var originalOpen = proto.open;
    proto.open = function (triggeredBy) {
      var wasOpen = this.classList.contains('active');
      originalOpen.call(this, triggeredBy);
      if (!wasOpen) sheen(this);
    };
  });

  customElements.whenDefined('cart-drawer-items').then(function () {
    var Items = customElements.get('cart-drawer-items');
    var proto = Items.prototype;
    var originalOnCartUpdate = proto.onCartUpdate;
    proto.onCartUpdate = function () {
      // Right after a product-form add, product-form.js has already
      // rendered the fresh drawer from the /cart/add.js response; Dawn's
      // extra re-fetch would only replace it again.
      if (Date.now() - addStartedAt < 4000) return Promise.resolve();
      var result = originalOnCartUpdate.apply(this, arguments);
      return Promise.resolve(result).then(function () {
        animateShip();
        announce();
      });
    };
  });

  // Quantity / remove (cart.js) publish cartUpdate after re-rendering.
  function listen() {
    lastShip = shipFraction();
    var d = drawer();
    if (lastShip === null && d && d.classList.contains('is-empty')) lastShip = 0;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'cart-items') return;
        animateShip();
        announce();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen);
  else listen();
})();
